//libs
import React, {useRef, useState} from 'react';
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";

// components
import Switch from "react-switch";
import axios from "../../../axios-defaults";
import {toast} from "react-toastify";
import Spinner from "../../UI/Spinner";

const NewCardForm = (props) => {

    const { subAccountType, subAccountCode } = props;
    const { t, i18n } = useTranslation();
	const [loading, setLoading] = useState(false);
	const { register, handleSubmit, watch, control, formState: { errors } } = useForm({defaultValues:{
			useOdometer: false,
			useMiscellaneous: false,
		}});


    const pin = useRef({});
    pin.current = watch("nip", "");

    const submitHandler = async data => {
		setLoading(true);

		axios.post(`/cards/newCreditCard`, data)
            .then(response => {
				if (response.data.succeeded) {
					setLoading(false);
					props.newCardSuccessModal();
				}
            })
            .catch(error => {
                toast.error(
                    <div>
                        <i className="fal fa-exclamation-circle"></i>&nbsp;{error.message}
                    </div>
                );
                console.log('[NewCardForm.js] : Ajax error in submitHandler()',error.message);
				setLoading(false);
			});
    };

    const displayErrors = (fieldname) => {
        let html = "";

        if(errors[fieldname]){
            let errorMessage = "";
            if(errors[fieldname].message){
                errorMessage = errors[fieldname].message;
            } else {
                switch(errors[fieldname].type){
                    case("required"): errorMessage = t("errors.fieldrequired"); break;
                    case("min"): errorMessage = t("errors.minval"); break;
                    case("max"): errorMessage = `${t("errors.maxval_credit_limit")} ${dayCreditLimit}. ${t("errors.maxval_credit_limit_end")}`; break;
                    default: errorMessage = t("errors.error"); break;
                }
            }
            html = (<p className="error">{ errorMessage }</p>)
        }

        return html;
    }

    return (
		loading ? <Spinner/> :
		<form className="cardmanager__form form" onSubmit={handleSubmit(submitHandler)} method="post">
				<fieldset className="fieldset">
					<h4 className="headline headline--section">
						{ t('account.cards.management.form.info_title') }
					</h4>
					<div className="row mb-4">
						<div className="col col-12 col-md-6">
							<div className={`input-field${errors.cardOwner ? ' input-field--error' : ''}`}>
								<label htmlFor="txt_cardholder" className="label">
									{ t('account.cards.management.form.cardholder_name_label') }
								</label>
								<div className="control">
									<input type="text" name="cardholder" id="txt_cardholder" autoComplete="off" {...register("cardOwner", {required: true}) } />
									{ displayErrors("cardOwner") }
								</div>
							</div>
						</div>
					</div>
					{subAccountType == 'K' &&
						<div className={`input-field toggle${errors.useOdometer ? ' input-field--error' : ''}`}>
							<label htmlFor="useOdometer" className="toggle__wrapper label">
								<div className="control">
									<Controller
										control={control}
										name="useOdometer"
										render={({
													 field: {onChange, onBlur, value, name, ref},
													 fieldState: {invalid, isTouched, isDirty, error},
													 formState,
												 }) => (
											<Switch
												onChange={onChange}
												checked={value}
												uncheckedIcon={false}
												checkedIcon={false}
												height={24}
												width={46}
												onColor="#55B545"
												inputRef={ref}
												id="useOdometer"
											/>
										)}
									/>
									<span className="toggle__label">
								{t('account.cards.management.form.odometer_toggle')}
							</span>
								</div>
								{displayErrors("useOdometer")}
							</label>
						</div>
					}
					{subAccountType == 'K' &&
						<div className={`input-field toggle${errors.useMiscellaneous ? ' input-field--error' : ''}`}>
							<label htmlFor="useMiscellaneous" className="toggle__wrapper label">
						<span className="control">
							<Controller
								control={control}
								name="useMiscellaneous"
								render={({
											 field: {onChange, onBlur, value, name, ref},
											 fieldState: {invalid, isTouched, isDirty, error},
											 formState,
										 }) => (
									<Switch
										onChange={onChange}
										checked={value}
										// checked={typeof value !== 'undefined' ? checked : false}
										uncheckedIcon={false}
										checkedIcon={false}
										height={24}
										width={46}
										onColor="#55B545"
										inputRef={ref}
										id="useMiscellaneous"
									/>
								)}
							/>
							<span className="toggle__label">
								{t('account.cards.management.form.misc_toggle')}
							</span>
						</span>
								{displayErrors("useOdometer")}
							</label>
						</div>
					}
				</fieldset>


				{subAccountType == 'K' &&
					<fieldset className="fieldset">
						<h4 className="headline headline--section">
							{ t('account.cards.management.form.pin_title') }
						</h4>
						<div className="row">
							<div className="col-md-6">
								<div className={`input-field switch${errors.nip ? ' input-field--error' : ''}`}>
									<label htmlFor="txt_pin" className="label">
										{ t('account.cards.management.form.pin_label') }
									</label>
									<div className="control">
										<input type="password"
											   name="pin"
											   id="txt_pin"
											   autoComplete="off"
											   {...register(
												   "nip",
												   {
													   pattern:{
														   value: /^(0|[1-9]\d*)(\.\d+)?$/,
														   message: t("errors.numbersonly")
													   },
													   minLength: {
														   value: 4,
														   message: t("errors.minlength") + " 4"
													   },
													   maxLength: {
														   value: 4,
														   message: t("errors.maxlength") + " 4"
													   }
												   }
											   )} />
										{ displayErrors("nip") }
									</div>
								</div>
							</div>
							<div className="col-md-6">
								<div className={`input-field switch${errors.nipConfirm ? ' input-field--error' : ''}`}>
									<label htmlFor="txt_pin_confirm" className="label">
										{ t('account.cards.management.form.pin_confirm_label') }
									</label>
									<div className="control">
										<input type="password"
											   name="pin_confirm"
											   id="txt_pin_confirm"
											   autoComplete="off"
											   {...register(
												   "nipConfirm",
												   {
													   pattern:{
														   value: /^(0|[1-9]\d*)(\.\d+)?$/,
														   message: t("errors.numbersonly")
													   },
													   minLength: {
														   value: 4,
														   message: t("errors.minlength") + " 4"
													   },
													   maxLength: {
														   value: 4,
														   message: t("errors.maxlength") + " 4"
													   },
													   validate: value => value === pin.current || t("errors.pinsnotmatch")
												   }
											   )} />
										{ displayErrors("nipConfirm") }
									</div>
								</div>
							</div>
						</div>
					</fieldset>
				}

				<input type="hidden" value={subAccountCode} {...register("subAccountCode")} />

				<fieldset className="fieldset form__actions">
					<button className="btn btn--outline btn--outline--gray action" onClick={props.closeModal}>
					<span className="btn__text">
						{ t('account.cards.management.buttons.cancel') }
					</span>
					</button>
					<button type="submit" className="btn btn--raised btn--raised--red action">
				<span className="btn__text">
					{ t('account.cards.management.new_card.send') }
				</span>
					</button>
				</fieldset>
			</form>
    );
};

export default NewCardForm;
